import { render, staticRenderFns } from "./ProjectInstruments.vue?vue&type=template&id=16893421"
import script from "./ProjectInstruments.vue?vue&type=script&lang=js"
export * from "./ProjectInstruments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports